import React from "react";
import Footer from "../Shared/Navbar/Footer/Footer";
import Navbar from "../Shared/Navbar/Navbar";

const Resume = () => {
  return (
    <div>
      <Navbar />
      Resume
      <Footer />
    </div>
  );
};

export default Resume;
